import React, { useState } from "react";

const useLogic = (content) => {
  const [enableImageEditor, setEnableImageEditor] = useState(false);
  const [enableEditor, setEnableEditor] = useState();
  const HandleEditBtnClick = () => {
    setEnableImageEditor((prev) => !prev);
  };
  React.useEffect(() => {
    if (content?.fileContent && content?.fileContent?.length > 0) {
      setEnableEditor(true);
    } else {
      setEnableEditor(false);
    }
  }, [content?.fileContent]);

  return {
    enableImageEditor,
    HandleEditBtnClick,
    setEnableImageEditor,
    enableEditor,
  };
};

export default useLogic;
